import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import { UserService } from '../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

  title = "Payment Methods";
  AppNo:any;
 today:any;
 ChallanCopies:any={};
 Total:any;
//  payment:any={};
 value:any;
 n_array:any;
 Amtwords:any;
 Mode:any;
 data:any;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { 
 
  }

  ngOnInit() {
    debugger;
        this.route.params.subscribe(params => {
        this.AppNo = params['AppNo'];
        this.Mode = params['Mode'];
        // this.ProjectID = params['ProjectID'];
      })
      // if(this.AppNo!=null)
      // this.GetKhbchallan(this.AppNo);
  }

  // GetKhbchallan(){
  //   debugger
  //   window.open(this.userService.rootUrl+"/Esign/Payment.aspx","_self");
  //   // window.open("http://localhost:14080/Esign/Payment.aspx","_self");
  //   // document.getElementById('loader-spinner').style.display = "block";
  //   // this.userService.GetKhbchallan(this.AppNo)
  //   //   .subscribe(
  //   //     (response:any) => {
  //   //     this.ChallanCopies=response;
  //   //     document.getElementById('loader-spinner').style.display = "none";
  //   //   }, (error) => {
  //   //     document.getElementById('loader-spinner').style.display = "none";
  //   //     this.errorHandler.HandlerError(error);
  //   //   });
  // }

  //By Sachin
  GetKhbchallan(){
    debugger
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetKhbAmountForPayment(this.AppNo)
      .subscribe(
        (response:any) => {
        this.ChallanCopies=response;
        // this.UpdatePaymentDetails();
        this.Total = parseFloat(this.ChallanCopies.PC_AppFee || 0) + parseFloat(this.ChallanCopies.PC_RegFee || 0)+ parseFloat(this.ChallanCopies.PC_InitialDeposit || 0);
        this.today = new Date();
        this.AppNo = 0;
        this.AppNo = this.ChallanCopies.APP_No;
        window.open("http://localhost:14080/Esign/Payment.aspx?Total="+ this.Total + "&AppNo=" + this.AppNo,"_self");
        // this.Amtwords=this.convertNumberToWords(this.Total);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  // GetKhbchallan() {
  //   //
  //   //window.open("http://localhost:14080/Esign/Payment.aspx");
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.Payment();
  //   this.data.subscribe(
  //     (response: any) => {
  //       // this.Alert = response;
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //       this.errorHandler.HandlerError(error);
  //     });
  // }


  // payment()
  // {
  //   swal.mixin({
  //     input: 'text',
  //     confirmButtonText: 'Next &rarr;',
  //     showCancelButton: true,
  //     progressSteps: ['1', '2', '3']
  //   }).queue([
  //     {
  //       title: 'Question 1',
  //       text: 'Chaining swal2 modals is easy'
  //     },
  //     'Question 2',
  //     'Question 3'
  //   ]).then((result) => {
  //     if (result.value) {
  //       swal({
  //         title: 'All done!',
  //         html:
  //           'Your answers: <pre>' +
  //           JSON.stringify(result.value) +
  //           '</pre>',
  //         confirmButtonText: 'Lovely!'
  //       })
  //     }
  //   })
  // }


payment(){
  swal({
    //title: '<i>HTML</i> <u>example</u>',
    //type: 'info',
    html:
      '<input placeholder="Bank Name" type="text" class="form-control"><br>' +
      '<input placeholder="Branch" type="text" class="form-control"><br>' +
      '<input placeholder="DD No." type="text" class="form-control"><br>' +
      '<input placeholder="DD Date" type="text" class="form-control"><br>' +
      '<input placeholder="Amount" type="text" class="form-control"><br>' +
      '<label>DD Copy</label><input style="width:70%;display:inline-block;margin-left:20px;"  type="file" class="form-control">' ,
      
    showCloseButton: true,
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonText:
      'Save',    
    cancelButtonText:
    'Cancel',
  })
}

}



// WEBPACK FOOTER //
// ./src/app/applicant/payment/payment.component.ts